function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "tommy3");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "tommy3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.512,85.4119 C54.242,85.4119 58.477,81.2539 58.477,75.6739 C58.477,70.0549 54.242,65.9329 48.512,65.9329 C42.818,65.9329 38.584,70.0549 38.584,75.6739 C38.584,81.2539 42.818,85.4119 48.512,85.4119 M48.512,62.5609 C56.94,62.5609 62.26,68.5559 62.26,75.6739 C62.26,82.5669 57.089,88.7829 48.436,88.7829 C40.083,88.7829 34.801,82.6039 34.801,75.6739 C34.801,68.5929 40.234,62.5609 48.512,62.5609",
  id: "Fill-14",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  fill: "#040C2B",
  points: "103.3167 88.4481 99.6467 88.4481 99.6467 68.5551 99.5707 68.5551 91.7047 78.4461 91.1037 78.4461 83.2387 68.5551 83.1637 68.5551 83.1637 88.4481 79.4917 88.4481 79.4917 62.8991 82.9387 62.8991 91.4047 73.3881 99.9087 62.8991 103.3167 62.8991"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-18",
  fill: "#040C2B",
  points: "147.8949 88.4481 144.2239 88.4481 144.2239 68.5551 144.1489 68.5551 136.2819 78.4461 135.6829 78.4461 127.8159 68.5551 127.7419 68.5551 127.7419 88.4481 124.0699 88.4481 124.0699 62.8991 127.5159 62.8991 135.9829 73.3881 144.4869 62.8991 147.8949 62.8991"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-20",
  fill: "#040C2B",
  points: "182.0208 62.8992 186.4428 62.8992 176.9628 74.9622 176.9628 88.4482 173.2928 88.4482 173.2928 74.9242 163.8158 62.8992 168.2368 62.8992 175.0898 71.7032"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-22",
  fill: "#040C2B",
  points: "239.2952 88.4481 235.6272 88.4481 235.6272 77.3221 221.3172 77.3221 221.3172 88.4481 217.6462 88.4481 217.6462 62.8991 221.3172 62.8991 221.3172 74.0251 235.6272 74.0251 235.6272 62.8991 239.2952 62.8991"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  fill: "#040C2B",
  points: "254.507 88.4482 258.174 88.4482 258.174 62.8992 254.507 62.8992"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-26",
  fill: "#040C2B",
  points: "276.9066 85.1502 288.4456 85.1502 288.4456 88.4482 273.2336 88.4482 273.2336 62.8992 276.9066 62.8992"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-27",
  fill: "#040C2B",
  points: "312.6253 66.1942 302.6583 66.1942 302.6583 73.2752 312.6253 73.2752 312.6253 76.5732 302.6583 76.5732 302.6583 88.4482 298.9853 88.4482 298.9853 62.8992 312.6253 62.8992"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-28",
  fill: "#040C2B",
  points: "325.474 88.4482 329.141 88.4482 329.141 62.8992 325.474 62.8992"
}), /*#__PURE__*/React.createElement("path", {
  d: "M364.0931,86.6864 C360.6841,88.1844 357.9131,88.7834 354.3571,88.7834 C346.5271,88.7834 340.7551,83.3144 340.7551,75.8244 C340.7551,68.2944 346.6751,62.5614 354.4681,62.5614 C357.4651,62.5614 359.5601,63.0494 363.5701,64.7354 L363.5701,68.4424 C360.5731,66.7954 357.4651,65.9334 354.3941,65.9334 C348.8491,65.9334 344.5381,70.1674 344.5381,75.7104 C344.5381,81.4044 348.8121,85.4124 354.8791,85.4124 C356.8641,85.4124 358.6631,84.9624 360.4251,84.4014 L360.4251,79.1564 L355.5131,79.1564 L355.5131,75.8614 L364.0931,75.8614 L364.0931,86.6864 Z",
  id: "Fill-29",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-30",
  fill: "#040C2B",
  points: "392.5648 66.1942 381.7378 66.1942 381.7378 73.9142 392.1898 73.9142 392.1898 77.2092 381.7378 77.2092 381.7378 85.1502 392.9028 85.1502 392.9028 88.4482 378.0648 88.4482 378.0648 62.8992 392.5648 62.8992"
}), /*#__PURE__*/React.createElement("path", {
  d: "M409.1224,74.0614 L411.4804,74.0614 C415.4174,74.0614 416.5414,72.0404 416.5044,69.9044 C416.4624,67.5054 415.0424,66.0464 411.4804,66.0464 L409.1224,66.0464 L409.1224,74.0614 Z M411.8934,62.8994 C417.0634,62.8994 420.2874,65.6344 420.2874,70.0544 C420.2874,73.0144 418.7514,75.2224 416.0144,76.3094 C418.3354,77.8454 419.7604,80.2064 421.7074,83.3904 C422.7944,85.1504 423.4324,86.0124 425.1944,88.4484 L420.8104,88.4484 L417.4374,83.2034 C414.0664,77.9574 412.5304,77.3594 410.6574,77.3594 L409.1224,77.3594 L409.1224,88.4484 L405.4494,88.4484 L405.4494,62.8994 L411.8934,62.8994 Z",
  id: "Fill-31",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#040C2B",
  points: "347.705 12.5802 425.197 12.5802 425.197 0.0002 347.705 0.0002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#040C2B",
  points: "347.705 50.3192 425.197 50.3192 425.197 37.7402 347.705 37.7402"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#FEFEFE",
  points: "347.706 37.7402 386.451 37.7402 386.451 12.5802 347.706 12.5802"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#BA001D",
  points: "386.45 37.7392 425.197 37.7392 425.197 12.5792 386.45 12.5792"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#ECECEB",
  points: "0 50.3192 77.492 50.3192 77.492 0.0002 0 0.0002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#040C2B",
  points: "0 12.5802 77.492 12.5802 77.492 0.0002 0 0.0002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  fill: "#ECECEB",
  points: "260.779 50.3192 338.271 50.3192 338.271 0.0002 260.779 0.0002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  fill: "#040C2B",
  points: "260.779 50.3192 338.271 50.3192 338.271 37.7402 260.779 37.7402"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#ECECEB",
  points: "173.853 50.3192 251.344 50.3192 251.344 0.0002 173.853 0.0002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#BA001D",
  points: "212.598 37.7402 251.344 37.7402 251.344 12.5802 212.598 12.5802"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  fill: "#ECECEB",
  points: "86.926 50.3192 164.418 50.3192 164.418 0.0002 86.926 0.0002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  fill: "#FEFEFE",
  points: "86.926 37.7402 125.672 37.7402 125.672 12.5802 86.926 12.5802"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#040C2B",
  points: "0 62.8992 0 66.1942 8.841 66.1942 8.841 88.4482 12.512 88.4482 12.512 66.1942 21.352 66.1942 21.352 62.8992"
})));

var SvgTommy3 = function SvgTommy3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "426px",
    height: "89px",
    viewBox: "0 0 426 89",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTommy3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tommy3.58bd2945.svg";
export { ForwardRef as ReactComponent };